import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AdjustmentTemplateModel } from 'src/app/core/template';

@Component({
  selector: 'kt-adjustment-template-modal',
  templateUrl: './adjustment-template-modal.component.html',
  styleUrls: ['./adjustment-template-modal.component.scss']
})
export class AdjustmentTemplateModalComponent implements OnInit {
  public template: AdjustmentTemplateModel;

  constructor(
    private dialogRef: MatDialogRef<AdjustmentTemplateModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { 
    this.template = data.template;
  }

  ngOnInit(): void {
  }

  onNoClick() {
    this.dialogRef.close();
  }

}
